import { render } from "./BaseNav.vue?vue&type=template&id=74c536fa&scoped=true"
import script from "./BaseNav.vue?vue&type=script&lang=js"
export * from "./BaseNav.vue?vue&type=script&lang=js"

import "./BaseNav.vue?vue&type=style&index=0&id=74c536fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c536fa"]])

export default __exports__